<template>

    <body class="dx-viewport">
        <DxDataGrid ref="dataGridRef" :allowColumnReordering="true" :data-source="dsBilantFormule"
            :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnMinWidth="50"
            :columnResizingMode="'nextColumn'" :show-borders="true" :syncLookupFilterValues="false"
            :filter-sync-enabled="true" show-row-lines="true" row-alternation-enabled="true" show-column-lines="false"
            @row-inserting="onRowInserting" @row-removing="onRowRemoving" class="border" :hover-state-enabled="true">
            <DxSelection mode="single" />
            <DxFilterRow :visible="true" />
            <DxPaging :page-size="5" :page-index="1" />
            <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
            <DxSorting mode="multiple" />
            <DxStateStoring :enabled="true" :filterValue="false" storage-key="BilantFormule" />
            <DxToolbar>
                <DxItem>
                    <template #default>
                        <DxButton icon="add" type="success" @click="onAddClick" />
                    </template>
                </DxItem>
                <DxItem>
                    <template #default>
                        <DxButton icon="refresh" @click="onRefreshClick" />
                    </template>
                </DxItem>
            </DxToolbar>
            <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup" @click="onRowRemoving">
                <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="550" :height="380">
                    <DxToolbarItem :template="customTitleTemplate" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after"
                        :options="successButtonOptions" />
                    <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
                </DxPopup>
                <DxFormGrid>
                    <DxItem :col-span="2" :col-count="2" item-type="group">
                        <DxItem data-field="ContID" :label="{ text: 'Bilant Cont' }" />
                        <DxItem data-field="Observatii" />
                        <DxItem data-field="Simbol" />
                    </DxItem>
                </DxFormGrid>
            </DxEditing>
            <DxColumn dataField="ContID" caption="Cont" :lookup="{
                dataSource: dsConturi,
                valueExpr: 'Id',
                displayExpr: 'Simbol'
            }" />
            <DxColumn dataField="Operator" />
            <DxColumn dataField="Simbol" />
            <DxColumn data-field="Observatii" />
            <DxColumn dataField="BilantRandID" :visible="false" />

        </DxDataGrid>
        <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false"
            :showTitle="true" :width="550" :height="390">
            <template #title>
                <div
                    style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                    Adăugare</div>
            </template>
            <div>
                <DxForm :formData="formData">
                    <DxItem :col-span="2" :col-count="2" item-type="group">
                        <DxItem data-field="Operator" />
                        <DxItem data-field="ContID" editor-type="dxLookup" :label="{ text: 'Cont' }" :editor-options="{
                            dataSource: dsConturi,
                            valueExpr: 'Id',
                            displayExpr: 'Simbol',
                            searchEnabled: true,
                            searchExpr: 'Simbol',
                            placeholder: 'Selectează cont'
                        }" />
                        <DxItem data-field="Observatii" />
                        <DxItem data-field="Simbol" />
                    </DxItem>
                </DxForm>
                <div style="display: flex; justify-content: flex-end; gap: 8px;">
                    <DxButton text="Salvează" type="success" width="100" @click="onSaveAdd" />
                    <DxButton text="Închide" type="danger" width="100" @click="onCancel" />
                </div>
            </div>
        </DxPopupAdd>
    </body>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import { DxItem, DxForm, DxLabel } from 'devextreme-vue/form';
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxPopup,
    DxItem as DxItemForm,
    DxForm as DxFormGrid,
    DxValidationRule,
    DxRequiredRule,
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { locale, loadMessages } from 'devextreme/localization';
import { DxLookup } from 'devextreme-vue';
import DxSelectBox from "devextreme-vue/select-box"
import ConBilantFormule from '@/services/Contabilitate/ConBilantFormule';
export default defineComponent({
    components: {
        DxToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxItem,
        DxPopup,
        DxForm,
        DxLabel,
        DxEditing,
        DxPopupAdd,
        DxToolbarItem,
        DxItemForm,
        DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxLookup,
        DxSelectBox
    },
    data() {
        return {
            dsBilantRanduri: {} as ODataStore,
            dsBilanturi: {} as ODataStore,
            dsConturi: {} as ODataStore,
            dsBilantFormule: {} as ODataStore,
            isModalVisible: false,
            dsConturiMap: new Map<string, string>(),
            formData: {
                BilantRandID: '',
                Operator: '',
                ContID: '',
                Observatii: '',
                Simbol: '',
            },
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            dataGridRef: ref<DxDataGrid | null>(null),
            successButtonOptions: {
                type: 'success',
                stylingMode: 'contained',
                text: 'Salvează',
                onClick: () => {
                    this.onSaveEdit();
                },
            },
            dangerButtonOptions: {
                type: 'danger',
                stylingMode: 'contained',
                text: 'Închide',
                onClick: () => {
                    this.onCancelEdit();
                },
            },
            customTitleTemplate() {
                return `
        <div style="background-color: #ff2c21; font-size: 16px; float: right; height:47px; width:570px; color: white; 
        font-weight: bold;  padding: 12px; padding-right: 450px;  position: relative;  left: 30px;">
          Editare
        </div>
      `;
            },
        };
    },
    props: {
        BilantRandID: {
            type: String,
            required: true
        },
        bilantData: {
            type: Object,
            required: true
        }
    },
    watch: {
        BilantRandID: {
            immediate: true,
            handler(newVal) {

                this.createODataContext(newVal);
            },
        },
    },
    methods: {
        createODataContext(BilantRandID) {
            this.dsBilantFormule = {
                store: new ODataStore({
                    url: AppSetting.API_Url_Contabilitate + 'CON_BilantFormule',
                    key: 'ID',
                    version: 4,
                    fieldTypes: {
                        BilantRandID: "Guid",
                        ID: "Guid"
                    },
                    beforeSend: (e) => {
                        e.headers = {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                        };
                    },
                }),
                filter: ['BilantRandID', '=', BilantRandID]
            };
            this.dsBilantRanduri = new ODataStore({
                url: AppSetting.API_Url_Contabilitate + 'CON_BilantRanduri',
                key: 'ID',
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                    };
                },
            });

        },
        onAddClick() {
            this.isModalVisible = true;
        },
        onSaveAdd() {
            this.formData.BilantRandID = this.BilantRandID;

            const body = this.formData;
            ConBilantFormule.save(body).then((response) => {
                this.isModalVisible = false;
                notify('Datele au fost salvate cu succes!', 'success', 1000);
                this.formData = {
                    BilantRandID: '',
                    Operator: '',
                    ContID: '',
                    Observatii: '',
                    Simbol: '',
                };
            }).catch((error) => {
                console.error(error);
                notify('Datele există deja!', 'error', 1000);
            });
        },
        onCancel() {
            this.isModalVisible = false;
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        onClick() {
            this.isModalVisible = true;
        },
        onRefreshClick() {
            this.createODataContext(this.BilantRandID);
            notify('Datele au fost actualizate cu succes!', 'success', 1000)
        },
        onSaveEdit() {
            const savePromise = this.$refs.dataGridRef?.instance?.saveEditData();
            savePromise.then((result) => {
                this.dataGridRef?.instance?.saveEditData();
            }).catch((error) => {
                console.error(error);
            });
            this.createODataContext();
        },
        onCancelEdit() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onRowRemoving(e: any) {
            e.cancel = new Promise((resolve) => {
                this.dataGridRef?.instance?.saveEditData();
                notify('Datele au fost șterse cu succes!', 'success', 1000);
                resolve(false);
            });
        },
        onRowInserting() {
            notify('Datele au fost adăugate cu succes!', 'success', 1000)
        },
    },
    async mounted() {
        this.createODataContext(this.BilantRandID);

        this.dsConturi = new ODataStore({
            url: AppSetting.API_Url_DocumenteOdata + 'CON_Conturi',
            key: 'Id',
            version: 4,
            beforeSend: (e) => {
                e.headers = {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
                };
            },
        });

        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
        this.setDeleteConfirmationMessage();

        loadMessages({
            "ro": {
                "Yes": "Da",
                "No": "Nu",
            }
        });
        locale('ro');
    }

});
</script>
<style scoped>
.border {
    border-radius: 8px;
}
</style>
